import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
function Categories({ subCategory }) {
  const { i18n} = useTranslation()
  return (
    <div className='containe my-5 categories-parent'>
      <div className="categories d-flex justify-content-center flex-nowrap overflow-x-auto">
        {subCategory?.map((subcat, index) => (
          <Link  className=" category-icon-div me-5"to={"/SubcatigoryPage/"+subcat._id+"/1"} key={index}>
            <div className=' category-icon-img-div'>
              <img className='category-icon-img' src={subcat.Image.secure_url} />
            </div>
            <p className=' category-icon-para'>{i18n.language == "en" ? subcat.name : subcat.nameAr}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
export default Categories;